import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/content";

const CtaBanner = () => (
    <section className="px-6 pb-24 lg:px-10 lg:pb-32" data-testid="cta-banner-section">
        <Reveal>
            <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-teal-dark lift-shadow">
                <img
                    src={IMAGES.texture}
                    alt=""
                    aria-hidden
                    className="absolute inset-0 h-full w-full object-cover opacity-25 mix-blend-luminosity"
                />
                <div className="relative z-10 px-8 py-16 text-center md:px-16 md:py-24">
                    <p className="text-xs font-medium uppercase tracking-[0.28em] text-saffron">Begin today</p>
                    <h2 className="mx-auto mt-5 max-w-3xl font-serif text-3xl font-semibold leading-[1.05] tracking-tight text-cream md:text-4xl">
                        One free lesson is all it takes to feel the difference.
                    </h2>
                    <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-cream/70 md:text-base">
                        Meet a teacher, see the classroom, and watch your child light up — before you spend a penny.
                    </p>
                    <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
                        <Link
                            to="/free-trial"
                            data-testid="cta-book-trial-button"
                            className="group inline-flex items-center gap-2 rounded-full bg-saffron px-8 py-4 text-sm font-medium text-cream transition-all duration-300 hover:-translate-y-1 hover:bg-saffron-dark"
                        >
                            Book My Free Trial
                            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                        </Link>
                        <Link
                            to="/contact"
                            data-testid="cta-contact-button"
                            className="inline-flex items-center gap-2 rounded-full border border-cream/30 px-8 py-4 text-sm font-medium text-cream transition-all duration-300 hover:-translate-y-1 hover:bg-cream hover:text-teal-dark"
                        >
                            Ask a Question
                        </Link>
                    </div>
                </div>
            </div>
        </Reveal>
    </section>
);
export default CtaBanner;
